import React, { ReactElement } from 'react'
import { PrimaryButton } from '../../components/Button'
import PageHeader from '../../components/PageHeader'

interface IProps {
  isSubmitting: boolean
  canSubmit: boolean
  onSubmit: () => void
}

const Ubos = ({ isSubmitting, canSubmit, ...props }: IProps): ReactElement => {

  return <div style={{ display: 'flex', flexDirection: 'column', gap: 20, fontSize: 14, paddingBottom: 30 }}>
    <div style={{ marginBottom: 20 }}>
      <PageHeader title="Review and submit" subTitle="Review terms and conditions and submit for verification" />
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', fontSize: 13 }}>
      <div>By clicking "Submit verification", you agree to Radom's terms and conditions.</div>
    </div>

    <PrimaryButton style={{ width: '100%' }} disabled={!canSubmit} isLoading={isSubmitting} onClick={props.onSubmit}>
      Submit verification
    </PrimaryButton>

    <div style={{ fontSize: 12, opacity: 0.5 }}>By submitting this information, you confirm that all details provided are accurate and complete. You acknowledge and agree to be bound by our <a href="https://www.radom.com/terms" target='_blank'>Terms of Service</a> and <a href="https://www.radom.com/terms" target='_blank'>Privacy Policy</a>.</div>
  </div>
}

export default Ubos
